import {
  StyleParamType,
  wixColorParam,
  wixFontParam,
  createStylesParams,
} from '@wix/tpa-settings';

export type IStylesParams = {
  productTitleColor: StyleParamType.Color;
  productTitleFont: StyleParamType.Font;
  productPriceColor: StyleParamType.Color;
  productPriceFont: StyleParamType.Font;
  productDescriptionColor: StyleParamType.Color;
  productDescriptionFont: StyleParamType.Font;
  backgroundColor: StyleParamType.Color;
  imageBorderColor: StyleParamType.Color;
  imageBorderWidth: StyleParamType.Number;
  imageCornerRadius: StyleParamType.Number;
  imageRatio: StyleParamType.Number;
  inputFieldBackgroundColor: StyleParamType.Color;
  inputFieldBorderColor: StyleParamType.Color;
  inputFieldBorderWidth: StyleParamType.Number;
  inputFieldFont: StyleParamType.Font;
  inputFieldColor: StyleParamType.Color;
  inputFieldTitlesColor: StyleParamType.Color;
  inputFieldTitlesFont: StyleParamType.Font;
  selectionButtonsCornerRadius: StyleParamType.Number;
  inputFieldsCornerRadius: StyleParamType.Number;
  ProductVariantsFillColorOpacity: StyleParamType.Color;
  ProductVariantsBorderColor: StyleParamType.Color;
  ProductVariantsBorderWidth: StyleParamType.Number;
  ProductVariantsSelectedBoxColor: StyleParamType.Color;
  ProductVariantsTextColor: StyleParamType.Color;
  ProductVariantsTextFont: StyleParamType.Font;
  AmountSelectorOptionFillColorOpacity: StyleParamType.Color;
  AmountSelectorOptionSelectedBoxColor: StyleParamType.Color;
  AmountSelectorOptionBorderColor: StyleParamType.Color;
  AmountSelectorOptionBorderWidth: StyleParamType.Number;
  AmountSelectorOptionTextColor: StyleParamType.Color;
  AmountSelectorOptionTextFont: StyleParamType.Font;
  AmountSelectorOptionCornerRadius: StyleParamType.Number;
  GiftCardRecipientFillColorOpacity: StyleParamType.Color;
  GiftCardRecipientTextColor: StyleParamType.Color;
  GiftCardRecipientTextFont: StyleParamType.Font;
  GiftCardRecipientSelectedBoxColor: StyleParamType.Color;
  GiftCardRecipientBorderColor: StyleParamType.Color;
  GiftCardRecipientBorderWidth: StyleParamType.Number;
  GiftCardRecipientCornerRadius: StyleParamType.Number;
  BuyNowButtonTextFont: StyleParamType.Font;
  BuyNowButtonTextColor: StyleParamType.Color;
  BuyNowButtonCornerRadius: StyleParamType.Number;
  BuyNowButtonBorderColor: StyleParamType.Color;
  BuyNowButtonBorderWidth: StyleParamType.Number;
  BuyNowButtonFillColorOpacity: StyleParamType.Color;
  AddToCartButtonTextFont: StyleParamType.Font;
  AddToCartButtonTextColor: StyleParamType.Color;
  AddToCartButtonCornerRadius: StyleParamType.Number;
  AddToCartButtonBorderColor: StyleParamType.Color;
  AddToCartButtonBorderWidth: StyleParamType.Number;
  AddToCartButtonFillColorOpacity: StyleParamType.Color;
};

const stylesParams = createStylesParams<IStylesParams>({
  productTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  productTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Page-title'),
  },
  productPriceColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  productPriceFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Heading-S'),
  },
  productDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  productDescriptionFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-L'),
  },
  backgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  imageBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2'),
  },
  imageBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  imageCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  imageRatio: {
    type: StyleParamType.Number,
    getDefaultValue: () => 3 / 2,
  },
  inputFieldBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  inputFieldBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  inputFieldBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  inputFieldFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M'),
  },
  inputFieldColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  inputFieldTitlesColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  inputFieldTitlesFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M'),
  },
  selectionButtonsCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  inputFieldsCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  ProductVariantsFillColorOpacity: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  ProductVariantsBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  ProductVariantsBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  ProductVariantsSelectedBoxColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  ProductVariantsTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  ProductVariantsTextFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M'),
  },
  AmountSelectorOptionFillColorOpacity: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(
        stylesParams.ProductVariantsFillColorOpacity,
      );
      return value;
    },
  },
  AmountSelectorOptionSelectedBoxColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(
        stylesParams.ProductVariantsSelectedBoxColor,
      );
      return value;
    },
  },
  AmountSelectorOptionBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(stylesParams.ProductVariantsBorderColor);
      return value;
    },
  },
  AmountSelectorOptionBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(stylesParams.ProductVariantsBorderWidth);
      return value;
    },
  },
  AmountSelectorOptionTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(stylesParams.ProductVariantsTextColor);
      return value;
    },
  },
  AmountSelectorOptionTextFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(stylesParams.ProductVariantsTextFont);
      return value;
    },
  },
  AmountSelectorOptionCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(
        stylesParams.selectionButtonsCornerRadius,
      );
      return value;
    },
  },
  GiftCardRecipientFillColorOpacity: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(
        stylesParams.ProductVariantsFillColorOpacity,
      );
      return value;
    },
  },
  GiftCardRecipientTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(stylesParams.ProductVariantsTextColor);
      return value;
    },
  },
  GiftCardRecipientTextFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(stylesParams.ProductVariantsTextFont);
      return value;
    },
  },
  GiftCardRecipientSelectedBoxColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(
        stylesParams.ProductVariantsSelectedBoxColor,
      );
      return value;
    },
  },
  GiftCardRecipientBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(stylesParams.ProductVariantsBorderColor);
      return value;
    },
  },
  GiftCardRecipientBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(stylesParams.ProductVariantsBorderWidth);
      return value;
    },
  },
  GiftCardRecipientCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(
        stylesParams.selectionButtonsCornerRadius,
      );
      return value;
    },
  },
  BuyNowButtonTextFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M'),
  },
  BuyNowButtonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  BuyNowButtonCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  BuyNowButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  BuyNowButtonBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  BuyNowButtonFillColorOpacity: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },

  AddToCartButtonTextFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M'),
  },
  AddToCartButtonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  AddToCartButtonCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  AddToCartButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  AddToCartButtonBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  AddToCartButtonFillColorOpacity: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
});

export default stylesParams;
